// extracted by mini-css-extract-plugin
module.exports = {"mobile":"360","tablet":"768","desktop":"1280","openCloseMenu":"_1LLPA","buttonLabel":"_1mNHP","opened":"_3R4dQ"};